import { gql } from '@apollo/client'

export const Query = gql`
  query AccommodationContactUsers($companyId: ID!, $userId: ID!) {
    users(companyId: $companyId, filters: { idEq: $userId }, first: 1) {
      nodes {
        id
        displayName
        email
        phone
      }
    }
  }
`
